<p-checkbox
  [class]="config().disabled ? 'checkbox--disabled' : ''"
  [inputId]="config().id"
  [binary]="true"
  [disabled]="config().disabled"
  [readonly]="config().disabled"
  [label]="config().label"
  [formControl]="control"
  (onBlur)="onTouched()"
/>
